import { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { AppLayout } from '@/components/layout/AppLayout'
import { ErrorBoundary } from '@/components/ErrorBoundary'

const LoginPage = lazy(() => import('@/pages/LoginPage'))
const RecipeListPage = lazy(() => import('@/pages/RecipeListPage'))
const RecipeDetailPage = lazy(() => import('@/pages/RecipeDetailPage'))
const RecipeCreatePage = lazy(() => import('@/pages/RecipeCreatePage'))
const RecipeEditPage = lazy(() => import('@/pages/RecipeEditPage'))
const CategoryManagementPage = lazy(() => import('@/pages/CategoryManagementPage'))
const CategoryRecipesPage = lazy(() => import('@/pages/CategoryRecipesPage'))
const TagRecipesPage = lazy(() => import('@/pages/TagRecipesPage'))
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'))
const VideoPlayerPage = lazy(() => import('@/pages/VideoPlayerPage'))

function LoadingSpinner() {
	return (
		<div className="flex min-h-screen items-center justify-center">
			<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
		</div>
	)
}

export default function App() {
	return (
		<ErrorBoundary>
			<Suspense fallback={<LoadingSpinner />}>
				<Routes>
					<Route path="/" element={<Navigate to="/recipes" replace />} />

					<Route path="/login" element={<LoginPage />} />

					<Route element={<ProtectedRoute />}>
						<Route path="/video" element={<VideoPlayerPage />} />
						<Route element={<AppLayout />}>
							<Route path="/recipes" element={<RecipeListPage />} />
							<Route path="/recipes/add" element={<RecipeCreatePage />} />
							<Route path="/recipes/:id" element={<RecipeDetailPage />} />
							<Route path="/recipes/:id/edit" element={<RecipeEditPage />} />
							<Route path="/categories" element={<CategoryManagementPage />} />
							<Route path="/categories/:id" element={<CategoryRecipesPage />} />
							<Route path="/tags/:id" element={<TagRecipesPage />} />
						</Route>
					</Route>

					<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</Suspense>
		</ErrorBoundary>
	)
}
